import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../components/ProgressCom";
import CustomPagination from "../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseProductCluster } from "./UseProductCluster";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import CategoryAutoComplete from "../productCategory/CategoryAutoComplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CountryAutocomplete from "../Countries/CountryAutocomplete";
import TargetAutoComplete from "../productTarget/TargetAutoComplete";
import IngAutoComplete from "../ingredients/IngAutoComplete";

export default function ClusterIngredient(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { addclusterIngredient } = UseProductCluster();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [name, setName] = useState("");

  const [addcategory, setAddcategory] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    id: props.ClusterID,
    ingredientID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "rowIndex",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "ingredientID",
      width: 80,
      align: "center",
      headerName: "کد عنصر",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "title",
      width: 220,
      align: "center",
      headerName: "نام عنصر",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 70,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.title,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addcategory",
      width: 40,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            sx={{ p: 0 }}
            onClick={() => {
              setAddcategory(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      open={props.show}
      onClose={() => props.setShow(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addcategory ? (
            <Typography color="secondary" variant="subtitle2">
              لیست عنصرها
            </Typography>
          ) : (
            <Typography variant="subtitle2">عنصر را انتخاب کنید</Typography>
          )}
          {!addcategory ? (
            <IconButton
              onClick={() => {
                props.setShow(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setAddcategory(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addcategory ? (
          <Box sx={{ height: "18rem" }}>
            {props.rows ? (
              <DataGrid
                className="ltr-grid"
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={props.rows ? props.rows : []}
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={
                  props.rows && props.rows.length ? props.rows.length : 1
                }
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    nofab: true,
                    noPageCount: true,
                    rowCount:
                      props.rows && props.rows.length ? props.rows.length : "",
                    isLtr: true,
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "id",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              pt: 1,
            }}
          >
            <IngAutoComplete
              cluster
              setter={setStateAdd}
              lvl7State={stateAdd}
              openDerawerIng={true}
            ></IngAutoComplete>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.ingredientID) {
                    enqueueSnackbar("عنصر را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setProgress(true);
                  addclusterIngredient(stateAdd, () => {
                    props.callback(props.ClusterID);
                    setAddcategory(false);
                    setStateAdd({ ...stateAdd, ingredientID: "" });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.ingredientID) {
                      enqueueSnackbar("عنصر را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    setProgress(true);
                    addclusterIngredient(stateAdd, () => {
                      props.callback(props.ClusterID);
                      setAddcategory(false);
                      setStateAdd({ ...stateAdd, ingredientID: "" });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShow(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"عنصر"}
          callback={() => {
            props.deleteCallback(deleteState.id);
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
